<template>
    <b-form
        :save-url="addUrl"
        @success="formSuccess"
        @failure="formFailure"
        v-slot="{ model, loading }"
        :save-params="{ api_key: currentUser.api_key }"
    >

        <div class="row">
            <validated-input
                class="col-6"
                label="Solution Partner Name"
                v-model="model.name"
                :rules="rules.name"
                :disabled="loading"
            />

            <div class="file-upload-wrapper col-6">
                <label class="field-label">Logo</label>

                <div
                    class="custom-file-input"
                    @click="triggerFileInput(loading)"
                >
                    <span>{{ model.logo ? model.logo.name : 'Browse' }}</span>
                </div>

                <input
                    ref="fileInput"
                    type="file"
                    class="hidden-file-input"
                    accept="image/*"
                    :disabled="loading"
                    @change="handleFileChange($event, model)"
                />
            </div>
        </div>

        <div class="row">
            <div class="col">
                <image-info :width="335" :height="150"/>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <validated-textarea
                    label="Description"
                    v-model="model.description"
                    :rules="rules.description"
                    :disabled="loading"
                />
            </div>
        </div>

        <div class="row">
            <validated-input
                class="col-6"
                label="Website link"
                v-model="model.website_link"
                :rules="rules.website_link"
                :disabled="loading"
            />

            <checkbox-input
                class="col-6"
                label="Disable"
                v-model="model.disabled"
                :rules="rules.disabled"
                :disabled="loading"
            />
        </div>

        <btn
            class="trn"
            size="sm"
            :loading="loading"
            color="primary"
            text="Save"
            loading-text="Saving..."
            :disabled="loading"
        />

    </b-form>
</template>

<script>
import urls from '../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'AddSolutionPartner',

    computed : {
        ...mapGetters(['currentUser'])
    },

    data () {
        return {
            addUrl : urls.admin.solutionPartner.addEdit,

            rules : {
                name : {
                    required : true
                },

                description : {
                    required : true,
                    max      : 240
                },

                logo : {
                    required : true
                },

                website_link : {
                    required : true
                },

                disabled : {
                    required : false
                }
            }
        };
    },

    methods : {

        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },

        handleFileChange (event, model) {
            const file = event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                URL.revokeObjectURL(image.src);

                if (image.width !== 335 || image.height !== 150) {
                    this.$notify(
                        'Please upload an image with dimensions 335 × 150 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    // Clear input
                    event.target.value = '';

                    // Clear model
                    this.$set(model, 'logo', null);

                    return;
                }

                // Valid image
                this.$set(model, 'logo', file);
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.$notify(
                'Successfully Added Solution Partner..!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );

                return;
            }

            if (json.errors) {
                Object.entries(json.errors).forEach(([field, message]) => {
                    this.$notify(
                        `${field}: ${message}`,
                        'Validation Error',
                        {
                            type : 'warning'
                        }
                    );
                });

                return;
            }

            this.$notify(
                'Something went wrong!',
                'Error',
                {
                    type : 'error'
                }
            );
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
    display: none;
}

.custom-file-input {
    width: 100%;
    height: 38px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;
    color: black;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: border-color .2s ease, box-shadow .2s ease;
}
</style>
